<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un juzgado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todos.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todas.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todas.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las áreas</option>
        <option v-for="Area in AreasRecepcion" :key="Area.AreaID" :value="Area.AreaID">{{Area.Descripcion}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        AreasRecepcion: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idOrden: Number,
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo,
        Ordenamiento: this.idOrden,
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAreaRecepcion", params);
    },
    methods: {
      cargaCatalogoDeAreasRecepcion: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba,
        this.parametros.Ordenamiento = this.idOrden,
        axios.post(api.conexion + api.TemisCivil.catalogos.AreasRecepcion, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.AreasRecepcion = respuesta.data.AreasRecepcion;
              this.idDelModelo = this.AreasRecepcion[0].AreaID;
              this.cambiaAreaRecInicial();
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value,
          Ordenamiento: this.idOrden,
        }

        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAreaRecepcion", params);
        this.$emit("valorParaElPadre", evento);
      },
      cambiaAreaRecInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAreaRecepcion", { llave: this.idDelInput, valor: this.idDelModelo });
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },
    created() {
      this.cargaCatalogoDeAreasRecepcion();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/AreasRecepcion.vue